import React from 'react'
import { ReactComponent as LocationIcon } from '../../../assets/icons/location.svg'
import s from './index.module.scss'
import classNames from 'classnames'

interface Props {
  region?: string
  className?: string
}

const Region = ({ region, className }: Props) => {
  if (!region) return null

  return (
    <div className={classNames(s.region, className)}>
      <LocationIcon />
      <span>Регіон</span>
      {region}
    </div>
  )
}

export default Region